import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'
import { encounterBodySchema } from '../actions.js'

export const ENCOUNTERS_HISTORY_INITIALIZE = 'ENCOUNTERS_HISTORY_INITIALIZE'
export const ENCOUNTERS_HISTORY_INITIALIZED = 'ENCOUNTERS_HISTORY_INITIALIZED'
export const ENCOUNTERS_HISTORY_UPDATE = 'ENCOUNTERS_HISTORY_UPDATE'
export const ENCOUNTERS_HISTORY_UPDATE_SUCCESS = 'ENCOUNTERS_HISTORY_SUCCESS'
export const ENCOUNTERS_HISTORY_UPDATE_ERROR = 'ENCOUNTERS_HISTORY_ERROR'
export const ENCOUNTERS_HISTORY_EDIT = 'ENCOUNTERS_HISTORY_EDIT'
export const ENCOUNTERS_HISTORY_CANCEL = 'ENCOUNTERS_HISTORY_CANCEL'

export function init (patientId, clientName) {
  return (dispatch, getState) => {
    let state = getState()
    clientName = state.globalVars?.params?.clientName

    if (!patientId || !clientName) {
      return null
    }

    dispatch({ type: ENCOUNTERS_HISTORY_INITIALIZE })

    return Promise.all([
      http.getRequest(`/patients/${patientId}/encounters`, {}, { clientName }),
      http.getRequest(`/patients/${patientId}/activity`, {}, { clientName })
    ])
      .then(([ response, { activity }]) => {
        let encounters = response?.sort((a, b) => a.updated_at - b.updated_at)

        dispatch({
          type: ENCOUNTERS_HISTORY_INITIALIZED,
          data: encounters,
          activity
        })
      })
  }
}

export function update (encounter, data) {
  const patientId = encounter.subject_id
  const validatedForm = encounterBodySchema.safeParse(data)
  console.log(encounterBodySchema)

  return (dispatch) => {
    if (!validatedForm.success) {
      return dispatch(notify('There was a form error when updating your encounter.', true))
    }
    dispatch({
      type: ENCOUNTERS_HISTORY_UPDATE,
      encounter
    })
    return http
      .putRequest(`/patients/${patientId}/encounters/${encounter.id}`, validatedForm.data)
      .then(response => {
        dispatch({
          type: ENCOUNTERS_HISTORY_UPDATE_SUCCESS,
          encounter: response
        })
        dispatch(notify('Encounter was updated'))
      })
      .catch(err => {
        dispatch({
          type: ENCOUNTERS_HISTORY_UPDATE_ERROR,
          error: err
        })
        dispatch(notify('There was an error updating your encounter.',
          true))
      })
  }
}

export function edit (encounter) {
  return (dispatch) => {
    dispatch({
      type: ENCOUNTERS_HISTORY_EDIT,
      encounter
    })
  }
}

export function cancel (encounter) {
  return (dispatch) => {
    dispatch({
      type: ENCOUNTERS_HISTORY_CANCEL,
      encounter
    })
  }
}
